import HyperLinkForAudit from "@/views/modules/audit-transactions/NewHyperLink.vue";
export const AuditColumns = [
  {
    prop: "descripcion",
    label: "Descripcion",
    minWidth: 180,
    fixed: true,
    sortable: true
  },
  {
    prop: "Enero",
    label: "Enero",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 1
    }
  },
  {
    prop: "Febrero",
    label: "Febrero",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 2
    }
  },
  {
    prop: "Marzo",
    label: "Marzo",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 3
    }
  },
  {
    prop: "Abril",
    label: "Abril",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 4
    }
  },
  {
    prop: "Mayo",
    label: "Mayo",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 5
    }
  },
  {
    prop: "Junio",
    label: "Junio",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 6
    }
  },
  {
    prop: "Julio",
    label: "Julio",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 7
    }
  },
  {
    prop: "Agosto",
    label: "Agosto",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 8
    }
  },
  {
    prop: "Septiembre",
    label: "Septiembre",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 9
    }
  },
  {
    prop: "Octubre",
    label: "Octubre",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 10
    }
  },
  {
    prop: "Noviembre",
    label: "Noviembre",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 11
    }
  },
  {
    prop: "Diciembre",
    label: "Diciembre",
    minWidth: 180,
    fixed: false,
    sortable: true,
    formatter: HyperLinkForAudit,
    cellAtrrs: {
      mes: 12
    }
  }
  // {
  //   prop: "diauno",
  //   label: "dia 1",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 1
  //   }
  // },
  // {
  //   prop: "diados",
  //   label: "dia 2",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 2
  //   }
  // },
  // {
  //   prop: "diatres",
  //   label: "dia 3",

  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 3
  //   }
  // },
  // {
  //   prop: "diacuatro",
  //   label: "dia 4",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 4
  //   }
  // },
  // {
  //   prop: "diacinco",
  //   label: "dia 5",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 5
  //   }
  // },
  // {
  //   prop: "diaseis",
  //   label: "dia 6",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 6
  //   }
  // },
  // {
  //   prop: "diasiete",
  //   label: "dia 7",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 7
  //   }
  // },
  // {
  //   prop: "diaocho",
  //   label: "dia 8",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 8
  //   }
  // },
  // {
  //   prop: "dianueve",
  //   label: "dia 9",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 9
  //   }
  // },
  // {
  //   prop: "diadiez",
  //   label: "dia 10",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 10
  //   }
  // },
  // {
  //   prop: "diaonce",
  //   label: "dia 11",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 11
  //   }
  // },
  // {
  //   prop: "diadoce",
  //   label: "dia 12",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 12
  //   }
  // },
  // {
  //   prop: "diatrece",
  //   label: "dia 13",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 13
  //   }
  // },
  // {
  //   prop: "diacatorce",
  //   label: "dia 14",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 14
  //   }
  // },
  // {
  //   prop: "diaquince",
  //   label: "dia 15",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 15
  //   }
  // },
  // {
  //   prop: "diadiesciseis",
  //   label: "dia 16",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 16
  //   }
  // },
  // {
  //   prop: "diadiecisiete",
  //   label: "dia 17",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 17
  //   }
  // },
  // {
  //   prop: "diadieciocho",
  //   label: "dia 18",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 18
  //   }
  // },
  // {
  //   prop: "diadiecinueve",
  //   label: "dia 19",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 19
  //   }
  // },
  // {
  //   prop: "diaveinte",
  //   label: "dia 20",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 20
  //   }
  // },
  // {
  //   prop: "diaveintiuno",
  //   label: "dia 21",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 21
  //   }
  // },
  // {
  //   prop: "diadveintidos",
  //   label: "dia 22",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 22
  //   }
  // },
  // {
  //   prop: "diaveintitres",
  //   label: "dia 23",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 23
  //   }
  // },
  // {
  //   prop: "diaveinticuatro",
  //   label: "dia 24",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 24
  //   }
  // },
  // {
  //   prop: "diaveinticinco",
  //   label: "dia 25",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 25
  //   }
  // },
  // {
  //   prop: "diaveintiseis",
  //   label: "dia 26",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 26
  //   }
  // },
  // {
  //   prop: "diaveintisiete",
  //   label: "dia 27",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 27
  //   }
  // },
  // {
  //   prop: "diaveintiocho",
  //   label: "dia 28",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 28
  //   }
  // },
  // {
  //   prop: "diaveintinueve",
  //   label: "dia 29",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 29
  //   }
  // },
  // {
  //   prop: "diatreinta",
  //   label: "dia 30",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 30
  //   }
  // },
  // {
  //   prop: "diatreintayuno",
  //   label: "dia 31",
  //   minWidth: 120,
  //   //fixed: true,
  //   sortable: true,
  //   formatter: HyperLinkForAudit,
  //   cellAtrrs: {
  //     dia: 31
  //   }
  // }
];
